module.exports = __webpack_public_path__ + "img/a5.c42ce1ed.jpg";